import en from "./en";
import es from "./es";
import fr from "./fr";
import ar from "./ar";

export const languages = {
  en: { name: "English", flag: "🇺🇸", dir: "ltr" },
  es: { name: "Español", flag: "🇪🇸", dir: "ltr" },
  fr: { name: "Français", flag: "🇫🇷", dir: "ltr" },
  ar: { name: "العربية", flag: "🇸🇦", dir: "rtl" },
};

export const translations: Record<string, any> = { en, es, fr, ar };

export function getTranslation(lang: string) {
  return translations[lang] || translations.en;
}
